exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host ::ng-deep img {\n  max-height: 100px;\n  max-width: 100%;\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: auto;\n  margin-right: auto; }\n\n:host ::ng-deep .warning-images {\n  text-align: center;\n  display: block;\n  margin-left: auto;\n  margin-right: auto; }\n\n:host ::ng-deep .img-upload {\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: auto;\n  margin-right: auto; }\n\n:host ::ng-deep .none-img {\n  background-color: black;\n  height: 100px;\n  width: 177px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/userdata-generation/components/image-upload/image-upload.component.scss
// module id = ../../../../../src/app/modules/models/userdata-generation/components/image-upload/image-upload.component.scss
// module chunks = main